import ApiService from './api';
import {
    AuthToken,
    LoginRequest,
    User,
    CreateUserRequest,
} from '../types';

export class AuthService {
    async login(loginData: LoginRequest): Promise<AuthToken> {
        const formData = new FormData();
        formData.append('username', loginData.username);
        formData.append('password', loginData.password);

        return ApiService.post<AuthToken>('/auth/login', formData);
    }

    async loginJson(loginData: LoginRequest): Promise<AuthToken> {
        return ApiService.post<AuthToken>('/auth/login-json', loginData);
    }

    async register(userData: CreateUserRequest): Promise<User> {
        return ApiService.post<User>('/auth/register', userData);
    }

    async getCurrentUser(): Promise<User> {
        return ApiService.get<User>('/auth/me');
    }

    async refreshToken(): Promise<AuthToken> {
        return ApiService.post<AuthToken>('/auth/refresh');
    }

    saveToken(token: string): void {
        localStorage.setItem('access_token', token);
    }

    getToken(): string | null {
        return localStorage.getItem('access_token');
    }

    removeToken(): void {
        localStorage.removeItem('access_token');
    }

    isAuthenticated(): boolean {
        return !!this.getToken();
    }
}

export default new AuthService();